import { PreMeetingInformation } from 'src/meetings/components/PreMeetingInformation';
import type { CalendarEvent } from 'src/meetings/models';

type Props = {
  event: CalendarEvent;
};

export const PreMeetingTab = ({ event }: Props) => {
  return <PreMeetingInformation event={event} />;
};
